const COMPARE_LIMITS = {
  regular: {
    topics: 10,
    creators: 5,
  },
  winner: {
    topics: 20,
    creators: 10,
  },
}

export default COMPARE_LIMITS
